const googleProducts = ['premium_subscribe', 'premium3month', 'premium6month'];
const appleProducts = ['premium_sub', 'premium3mth', 'premium6mth'];

export function appleRestoreReceipt(value) {
  if (typeof value === 'string' && value.trim().startsWith('{')) value = JSON.parse(value);
  if (value && typeof value === 'object') value = value.receipt || value.latest_receipt;
  return typeof value === 'string' && value.length ? value : null;
}

export function purchaseCandidates(provider, data) {
  const parsed = typeof data === 'string' ? JSON.parse(data) : data;
  const rows = Array.isArray(parsed) ? parsed : [parsed];
  const found = [], seen = new Set();
  for (const row of rows) {
    if (!row || typeof row !== 'object') continue;
    const productId = row.productId || (Array.isArray(row.products) && row.products.length === 1 ? row.products[0] : null);
    const receipt = provider === 'google' ? row.purchaseToken : row.receipt;
    if (!(provider === 'google' ? googleProducts : appleProducts).includes(productId) || typeof receipt !== 'string' || !receipt) continue;
    // Queue purchased (0) AND pending (4) tokens for server verification. Only the server grants rights.
    // This keeps a later-completed pending payment recoverable even if the app closes.
    if (provider === 'google' && ![0, '0', 4, '4'].includes(row.purchaseState)) continue;
    const key = `${productId}:${receipt}`;
    if (!seen.has(key)) { seen.add(key); found.push({ productId, receipt }); }
  }
  return found;
}
